import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, UrlTree } from '@angular/router';
import { APP_ROUTES } from '@app/app.routes';
import { EONBOARDING_STEPS } from '@app/core/enums/onboarding.enum';
import { AppFacade } from '@app/facades/app.facade';
import { CustomerFacade } from '@app/facades/customer.facade';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {EVALIDATOR_COMPLETED} from "@core/enums/customer.enum";

@Injectable({
  providedIn: 'root',
})
export class BiometricsGuard implements CanActivate {
  constructor(
    private _appFacade: AppFacade,
    private _customerFacade: CustomerFacade,
    private _route: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this._checkBiometricsPage();
  }

  private _checkBiometricsPage(): Observable<boolean | UrlTree> {
    return this._checkBiometricsInfoComplete().pipe(
      map((isBiometricsInfoComplete) => {
        const route: string = APP_ROUTES.WAITING_ROOM;
        return isBiometricsInfoComplete ? true : this._route.createUrlTree([route]);
      })
    );
  }

  private _checkBiometricsInfoComplete(): Observable<boolean> {
    return combineLatest([
      this._appFacade.step$,
      this._appFacade.transactions$,
      this._customerFacade.customerValidation$,
    ]).pipe(
      map(([step, transactions, validation]) => {
        const haveTransactions: boolean = !!transactions;
        const haveValidation: boolean = !!validation;
        const isBiometricsValidator: boolean = (
          validation?.validator_completed == EVALIDATOR_COMPLETED.BIOMETRICS
        );
        return haveTransactions && haveValidation && isBiometricsValidator;
      })
    );
  }
}
